export default defineNuxtPlugin(async (nuxtApp) => {
  const RuntimeConfig = useRuntimeConfig()
  const authStore = useAuthStore()
  const userStore = useUserStore()
  const api = useApi()

  let iframe

  if (!document.getElementById('iframe')) {
    iframe = document.createElement('iframe')
    iframe.setAttribute('id', 'iframe')
    iframe.src = RuntimeConfig.public.GAME_URL
    // iframe.style.height = iframeHeight.value
    iframe.width = '100%'
    iframe.setAttribute('allowfullscreen', 'true')

    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      document.body.appendChild(iframe)
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        document.body.appendChild(iframe)
      })
    }
  }

  const searchParams = new URLSearchParams(window.location.search)
  const refreshToken = searchParams.get('rt')

  const playdeck = searchParams.get('playdeck')
  userStore.playdeck = playdeck

  if (userStore.playdeck) {
    window.parent.window.postMessage(
      { playdeck: { method: 'loading', value: 100 } },
      '*',
    )
  }

  userStore.setTgWebAppStartParam()

  if (refreshToken) {
    authStore.refreshToken = refreshToken
  } else if (!authStore.refreshToken) {
    await authStore.auth()
  }

  if (authStore.refreshToken && !authStore.accessToken) {
    await authStore.refreshAuth()
  }
})
